import React, { Component } from 'react';
import Layout from './Common/layout/index';
import appConfig from './Common/config/app-brand-config.json';
import commonStore from './Common/stores/commonStore';

class App extends Component {

  componentDidMount() {
    this.startup();
  }

  startup = async () => {
    commonStore.appName = appConfig.appName;
  };

  render() {
    return <Layout />;
  }
}

export default App;
